import 'css-chunksrc/client/scenes/secondaryCriteriaTemplate/viewSelector/styles.scss';export default {
  "viewSelector": "_viewSelector_tnki6_1",
  "input": "_input_tnki6_5",
  "icon": "_icon_tnki6_21",
  "listRoot": "_listRoot_tnki6_29",
  "list": "_list_tnki6_29",
  "item": "_item_tnki6_43",
  "selected": "_selected_tnki6_54",
  "open": "_open_tnki6_58"
};